import {
  createRootRouteWithContext,
  Outlet,
  useLocation
} from "@tanstack/react-router";

import { AbortOnRouteChange } from "@/components";
import { NotFoundPage } from "@/errors/pages/not-found-page";
import { DashboardLayout, PreviewLayout } from "@/layouts";
import { useIsAuthenticated } from "@/modules/auth/hooks/use-is-authenticated";
import { NotificationProvider } from "@/providers";
import type { RouterContext } from "@/router";

// eslint-disable-next-line react-refresh/only-export-components
const OutletComponent = () => {
  return (
    <>
      <NotificationProvider />
      <AbortOnRouteChange />
      <Outlet />
    </>
  );
};

// eslint-disable-next-line react-refresh/only-export-components
const RootComponent = () => {
  const location = useLocation();
  const isAuthLayout = location.pathname.split("/")[1] === "auth";
  const isPreviewLayout = location.pathname === "/products/list/preview";
  const isReviewLayout =
    location.pathname.startsWith("/products/list/") &&
    location.pathname.endsWith("/review");
  const isAuthenticated = useIsAuthenticated();

  if (isAuthLayout) {
    return <OutletComponent />;
  }

  if (isPreviewLayout || isReviewLayout) {
    return (
      <PreviewLayout>
        <OutletComponent />
      </PreviewLayout>
    );
  }

  if (!isAuthLayout && isAuthenticated) {
    return (
      <DashboardLayout>
        <OutletComponent />
      </DashboardLayout>
    );
  }

  return <OutletComponent />;
};

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootComponent,
  notFoundComponent: () => <NotFoundPage />
});
